import { Descriptions, Skeleton } from 'antd'
import { FC, memo, ReactNode } from 'react'
import styled from 'styled-components'

export type DescriptionItem = readonly [
  label: string,
  value: ReactNode,
  extra?: ReadonlyArray<ReactNode>,
]

const StyledDescriptions = styled(Descriptions)`
  && .ant-descriptions-view > table {
    table-layout: fixed;
    width: 100%;
  }

  &&& .ant-descriptions-row > .ant-descriptions-item-label {
    width: 36%;
    padding: 1rem 0.75rem;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  &&& .ant-descriptions-row > .ant-descriptions-item-content {
    width: 64%;
    min-width: 0;
    padding: 1rem 0.75rem;
    overflow-wrap: anywhere;
  }
`

const StyledSkeletonInput = styled(Skeleton.Input)`
  width: 100%;
  max-width: 12.5rem;
`

const RawOptionalDescriptions: FC<{
  items: ReadonlyArray<DescriptionItem>
  isLoading: boolean
}> = ({ items, isLoading }) => {
  return (
    <StyledDescriptions column={1} bordered>
      {items.map(([label, value, extra]) => (
        <Descriptions.Item key={label} label={label}>
          {isLoading ? (
            <StyledSkeletonInput active size='small' />
          ) : (
            <>
              {value}
              {extra}
            </>
          )}
        </Descriptions.Item>
      ))}
    </StyledDescriptions>
  )
}

export const OptionalDescriptions = memo(RawOptionalDescriptions)
